const translations = {
    deleteFlightReportError: `Failed to delete flight report with ID(s): {{flightReportIds}}`
};

export default translations;
